import { render, staticRenderFns } from "./ItineraryCard.vue?vue&type=template&id=efa32126&"
import script from "./ItineraryCard.vue?vue&type=script&lang=js&"
export * from "./ItineraryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports